import React from 'react';
import Link from 'gatsby-link'

import styles from './Apply.module.scss';

const Apply = (props) => (
  <div className={styles.Apply} style={props.style}>
    <h2 className="h2">{props.title}</h2>
    {
        props.content &&
        <p dangerouslySetInnerHTML={{ __html: props.content }} />
    }
    { props.buttonTitle ?
        <a className={ styles.Button } href={ props.buttonUrl } target="_blank">{ props.buttonTitle }</a> :
        <Link to={ props.buttonUrl ? props.buttonUrl : '/academy/apply/' } className={styles.Button}>{props.buttonText ? props.buttonText : 'Apply Now'}</Link>
    }
  </div>
)

export default Apply;



// WEBPACK FOOTER //
// ./src/components/Apply/index.js